export const DISPLAY_STATUS = Object.freeze({
  DISPLAY_TO_CLIENT: "Display to Client",
  INCLUDE_IN_PRICE: "Include in Price",
  SUBTRACT_FROM_MARGIN: "Subtract From Margin",
});

export const DISPLAY_STATUS_OPTIONS = Object.freeze({
  STANDARD: [
    { id: DISPLAY_STATUS.DISPLAY_TO_CLIENT, name: DISPLAY_STATUS.DISPLAY_TO_CLIENT },
    { id: DISPLAY_STATUS.INCLUDE_IN_PRICE, name: DISPLAY_STATUS.INCLUDE_IN_PRICE },
  ],
  INTERNATIONAL: [
    { id: DISPLAY_STATUS.DISPLAY_TO_CLIENT, name: DISPLAY_STATUS.DISPLAY_TO_CLIENT },
    { id: DISPLAY_STATUS.INCLUDE_IN_PRICE, name: DISPLAY_STATUS.INCLUDE_IN_PRICE },
    { id: DISPLAY_STATUS.SUBTRACT_FROM_MARGIN, name: DISPLAY_STATUS.SUBTRACT_FROM_MARGIN },
  ],
});

export const DISPLAY_STATUS_ALIASES = Object.freeze({
  [DISPLAY_STATUS.DISPLAY_TO_CLIENT]: [
    "display to client",
    "display_to_client",
    "displaytoclient",
    "show to client",
    "show_to_client",
    "visible to client",
    "visible_to_client",
  ],
  [DISPLAY_STATUS.INCLUDE_IN_PRICE]: [
    "include in price",
    "include_in_price",
    "included in price",
    "included_in_price",
    "includeinprice",
  ],
  [DISPLAY_STATUS.SUBTRACT_FROM_MARGIN]: [
    "subtract from margin",
    "subtract_from_margin",
    "subtractfrommargin",
    "pass through",
    "pass_through",
  ],
});

const toKey = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");

const ALIAS_LOOKUP = Object.entries(DISPLAY_STATUS_ALIASES).reduce((acc, [canonical, aliases]) => {
  acc[toKey(canonical)] = canonical;
  for (const alias of aliases) {
    acc[toKey(alias)] = canonical;
  }
  return acc;
}, {});

export const normalizeDisplayStatus = (
  rawValue,
  {
    fallback = DISPLAY_STATUS.DISPLAY_TO_CLIENT,
    allowed = null,
  } = {}
) => {
  const canonical = ALIAS_LOOKUP[toKey(rawValue)] || fallback;
  if (!Array.isArray(allowed) || allowed.length === 0) {
    return canonical;
  }
  return allowed.includes(canonical) ? canonical : fallback;
};
